module.exports = __webpack_public_path__ + "img/System Setting.1afbbc95.svg";